"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceMode = exports.isDeviceInBootloaderMode = void 0;
const isDeviceInBootloaderMode = (device) => !!device?.features?.bootloader_mode;
exports.isDeviceInBootloaderMode = isDeviceInBootloaderMode;
const getDeviceMode = (device) => {
    if (device?.features?.bootloader_mode)
        return 'bootloader';
    if (!device?.features?.initialized)
        return 'initialize';
    if (device?.features?.no_backup)
        return 'seedless';
    return 'normal';
};
exports.getDeviceMode = getDeviceMode;
//# sourceMappingURL=modeUtils.js.map